import React from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Outlet } from "react-router-dom";
import "../../src/App.css";

export const Layout = () => {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/919167860213"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="whatsapp-svg"
        >
          <path
            fill="white"
            d="M16.01 3C8.82 3 3 8.82 3 16c0 2.53.74 4.98 2.13 7.09L3 29l6.09-2.08A12.94 12.94 0 0016.01 29C23.18 29 29 23.18 29 16S23.18 3 16.01 3zm0 23.67c-2.08 0-4.11-.56-5.88-1.61l-.42-.25-3.61 1.23 1.18-3.52-.27-.43A10.6 10.6 0 015.33 16c0-5.88 4.79-10.67 10.68-10.67 5.88 0 10.66 4.79 10.66 10.67s-4.78 10.67-10.66 10.67zm5.85-7.99c-.32-.16-1.88-.93-2.17-1.04-.29-.11-.5-.16-.71.16-.21.32-.82 1.04-1 1.25-.18.21-.36.24-.68.08-.32-.16-1.33-.49-2.53-1.56-.94-.84-1.58-1.88-1.77-2.2-.18-.32-.02-.49.14-.65.14-.14.32-.36.48-.54.16-.18.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.72-.97-2.36-.26-.62-.52-.54-.71-.55h-.61c-.21 0-.56.08-.85.4-.29.32-1.11 1.08-1.11 2.64 0 1.56 1.14 3.07 1.3 3.28.16.21 2.24 3.42 5.43 4.8.76.33 1.35.52 1.81.67.76.24 1.45.21 1.99.13.61-.09 1.88-.77 2.14-1.52.26-.75.26-1.4.18-1.52-.08-.12-.29-.2-.61-.36z"
          />
        </svg>
      </a>
    </>
  );
};